import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  CircularProgress,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@material-ui/core";
import { ExpandMore, History as HistoryIcon } from "@material-ui/icons";
import { formatHistoryRow } from "../utils/formatters";

interface CoreInfoHistoryAccordionProps {
  classes: any;
  historyLoading: boolean;
  requestHistoryData: any[];
}

const CoreInfoHistoryAccordion: React.FC<CoreInfoHistoryAccordionProps> = ({
  classes,
  historyLoading,
  requestHistoryData,
}) => {
  return (
    <Accordion className={classes.accordion} defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMore />} className={classes.accordionSummary}>
        <Typography className={classes.cardTitle}>
          <HistoryIcon /> Core Info Request History
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {historyLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px" width="100%">
            <CircularProgress />
          </Box>
        ) : requestHistoryData.length === 0 ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px" width="100%">
            <Typography color="textSecondary">No history data available</Typography>
          </Box>
        ) : (
          <TableContainer component={Paper} elevation={0}>
            <Table className={classes.historyTable}>
              <TableHead>
                <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell>
                    <strong>Status</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Requested Fields</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Remark</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Accomplish Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Responded Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Created By</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Updated By</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Created Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Updated Date</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {requestHistoryData.map((history, index) => {
                  const formattedRow = formatHistoryRow(history);
                  return (
                    <TableRow key={index} hover>
                      <TableCell>{formattedRow.status}</TableCell>
                      <TableCell>{formattedRow.requestedFields}</TableCell>
                      <TableCell>{formattedRow.remark}</TableCell>
                      <TableCell>{formattedRow.accomplishDate}</TableCell>
                      <TableCell>{formattedRow.respondedDate}</TableCell>
                      <TableCell>{formattedRow.createdBy}</TableCell>
                      <TableCell>{formattedRow.updatedBy}</TableCell>
                      <TableCell>{formattedRow.createdDate}</TableCell>
                      <TableCell>{formattedRow.updatedDate}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default CoreInfoHistoryAccordion;
